import { ReactElement, useMemo } from 'react';
import { Stack } from '@mui/material';

import { useAppSelector } from '~hooks/useAppSelector';
import { selectAuth } from '~store/slices/auth/index';
import { isOnlyCreatorOrder } from '~utils/user';

import { useDashboardVariantV2CarrierContext } from '../../Context';

import DashboardVariantV2CarrierCollectWidgetCard from './Collect';
import DashboardVariantV2CarrierInWarehouseWidgetCard from './InWarehouse';
import DashboardVariantV2CarrierInTransitWidgetCard from './InTransit';
import DashboardVariantV2CarrierFinalizedWidgetCard from './Finalized';
import DashboardVariantV2CarrierActionsWidgetCard from './Actions';

const DashboardVariantV2CarrierHeaderWidgets = (): ReactElement => {
  const { user } = useAppSelector(selectAuth);

  const {
    statistics: {
      data: {
        companyInfo: { quantityGiverCompanies },
      },
    },
  } = useDashboardVariantV2CarrierContext();

  const isEnabledCollect = useMemo(
    () => (isOnlyCreatorOrder(user) ? false : quantityGiverCompanies > 0),
    [quantityGiverCompanies, user],
  );

  return (
    <Stack spacing={1.5} direction="row">
      {isEnabledCollect && <DashboardVariantV2CarrierCollectWidgetCard />}

      <DashboardVariantV2CarrierInWarehouseWidgetCard />

      <DashboardVariantV2CarrierInTransitWidgetCard />

      <DashboardVariantV2CarrierFinalizedWidgetCard />

      <DashboardVariantV2CarrierActionsWidgetCard />
    </Stack>
  );
};

export default DashboardVariantV2CarrierHeaderWidgets;
